import { render, staticRenderFns } from "./SoldApplianceList.vue?vue&type=template&id=7f08c180&scoped=true"
import script from "./SoldApplianceList.vue?vue&type=script&lang=js"
export * from "./SoldApplianceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f08c180",
  null
  
)

export default component.exports